import { useQuery } from "@tanstack/react-query";
import { apiDelete, get, patch, post } from "./divertidogsApiUtils";
import { MetodoPago } from "./ventasServicios";
import { AgendamientoResumido } from "./agendamientosServicios";
import { Pagina } from "./Pagina";

export type HorarioSpa = "MANANA" | "TARDE";
export const PrettyHorarioSpa: Record<HorarioSpa, string> = {
  MANANA: "Mañana",
  TARDE: "Tarde",
};
export interface NuevoAgendamientoSpa {
  idMascota: string;
  datosReservaSpa: {
    datosTarifa: {
      idTarifa: string;
      precioFinal: number;
    };
    fechasProgramadas: Date[];
    horario: HorarioSpa;
  };
  datosPago?: { metodo: MetodoPago; monto: number };
  descuento: number;
}

export const agendarSpa = async (
  nuevoAgendamientoSpa: NuevoAgendamientoSpa
): Promise<undefined> => {
  return post<NuevoAgendamientoSpa, undefined>(
    "agendamientos/spa",
    nuevoAgendamientoSpa
  );
};

export interface AgendamientoSpaResumido extends AgendamientoResumido {
  reservaSpa: ReservaSpa;
}

export const isAgendamientoSpaResumido = (
  agendamientoResumido: AgendamientoResumido
): agendamientoResumido is AgendamientoSpaResumido => {
  return (
    agendamientoResumido.tipoServicio === "SPA" &&
    "reservaSpa" in agendamientoResumido
  );
};

export interface ReservaSpa {
  tarifa: string;
  precioFinalTarifa: number;
  horario: string;
  total: number;
  fechasProgramadas: string[];
}

const buscarAgendamientoDeReservaSpa = async (idReservaSpa: string) => {
  let response = await get<AgendamientoSpaResumido>(
    `agendamientos/spa/reservas/${idReservaSpa}`
  );
  return response;
};

export const QUERY_BUSCAR_AGENDAMIENTO_DE_RESERVA_SPA =
  "QUERY_BUSCAR_AGENDAMIENTO_DE_RESERVA_SPA";

export const useBuscarAgendamientoDeReservaSpa = (
  idReservaSpa: string,
  enabled: boolean
) =>
  useQuery({
    queryKey: [QUERY_BUSCAR_AGENDAMIENTO_DE_RESERVA_SPA],
    queryFn: async () => await buscarAgendamientoDeReservaSpa(idReservaSpa),
    enabled: enabled,
  });

export type ReagendamientoRequest = {
  idReservaSpa: string;
  fechas: Record<string, string>;
};

export const reagendarSpa = async ({
  idAgendamiento,
  request,
}: {
  idAgendamiento: string;
  request: ReagendamientoRequest;
}) => {
  return patch(`agendamientos/spa/${idAgendamiento}/reagendar`, request);
};

export const eliminar = async (idAgendamiento: string) => {
  return apiDelete(`agendamientos/spa/${idAgendamiento}`);
};

export type AgendamientoListado = {
  id: string;
  nombrePropietario: string;
  nombreMascota: string;
  fechaRealizacion: string;
  nombreServicio: string;
  fueCancelado: boolean;
};

export const listarTodos = async (
  queryParamsStr: string
) => {
  let response = await get<Pagina<AgendamientoListado>>(
    `agendamientos/spa${queryParamsStr}`
  );
  return response;
};

export const QUERY_LISTAR_TODOS_AGENDAMIENTOS_SPA =
  "QUERY_LISTAR_TODOS_AGENDAMIENTOS_SPA";

export const buscarPorId = async (id: string) => {
  return get<AgendamientoSpaResumido>(`agendamientos/spa/${id}`);
}

export const QUERY_BUSCAR_AGENDAMIENTO_SPA_POR_ID =
  "QUERY_BUSCAR_AGENDAMIENTO_SPA_POR_ID";

export const useBuscarPorId = (
  id: string
) =>
  useQuery({
    queryKey: [QUERY_BUSCAR_AGENDAMIENTO_SPA_POR_ID],
    queryFn: async () =>
      await buscarPorId(id)
  });